import { toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.typeshowflag === 1 && _ctx.$attrs.typelist.length > 0 && $data.isUseComp1 ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(["typeul", `fid${_ctx.$route.query.fid}`]),
    style: _normalizeStyle(_ctx.$attrs.posstyle)
  }, [_withDirectives(_createElementVNode("li", {
    style: _normalizeStyle($data.typeIndex === 0 ? $data.typebtn[1] : $data.typebtn[0]),
    class: _normalizeClass({
      'active': $data.typeOneIndex === 0
    }),
    onClick: _cache[0] || (_cache[0] = $event => $options.typeClick(_ctx.item, 0))
  }, _toDisplayString(_ctx.$attrs.typeallname), 7), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass({
        'active': $data.typeOneIndex === index + 1
      }),
      onClick: $event => $options.typeClick(item, index + 1)
    }, [_createElementVNode("span", {
      style: _normalizeStyle($data.typeIndex === index + 1 ? $data.typebtn[1] : $data.typebtn[0])
    }, _toDisplayString(item.itemformdata.title), 5), $options.getChildren(item, 0) ? (_openBlock(), _createElementBlock("ul", {
      key: 0,
      class: _normalizeClass(["ulchild", [$data.ulchildClass]]),
      style: _normalizeStyle($data.ulchildSstyle)
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getChildren(item, 1), (child, ids) => {
      return _openBlock(), _createElementBlock("li", {
        key: ids,
        style: _normalizeStyle($data.ctypeArr[index] === ids ? $data.typebtn[1] : $data.typebtn[0]),
        onClick: _withModifiers($event => $options.childtypeClick(item, index + 1, child, ids), ["stop"])
      }, _toDisplayString(child.title), 13, _hoisted_2);
    }), 128))], 6)) : _createCommentVNode("", true)], 10, _hoisted_1);
  }), 128))], 6)) : _createCommentVNode("", true), _ctx.$attrs.typeshowflag === 1 && _ctx.$attrs.typelist.length > 0 && !$data.isUseComp1 ? (_openBlock(), _createElementBlock("ul", {
    key: 1,
    class: _normalizeClass(["typeul", `fid${_ctx.$route.query.fid}`]),
    style: _normalizeStyle(_ctx.$attrs.posstyle)
  }, [_withDirectives(_createElementVNode("li", {
    style: _normalizeStyle($data.typeIndex === 0 ? $data.typebtn[1] : $data.typebtn[0]),
    onClick: _cache[1] || (_cache[1] = $event => $options.typeClick(_ctx.item, 0))
  }, _toDisplayString(_ctx.$attrs.typeallname), 5), [[_vShow, _ctx.$attrs.showtypeall]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.typelist, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      onClick: $event => $options.typeClick(item, index + 1)
    }, [_createElementVNode("span", {
      style: _normalizeStyle($data.typeIndex === index + 1 ? $data.typebtn[1] : $data.typebtn[0])
    }, _toDisplayString(item.itemformdata.title), 5), $options.getChildren(item, 0) ? (_openBlock(), _createElementBlock("ul", {
      key: 0,
      class: _normalizeClass(["ulchild", [$data.ulchildClass]]),
      style: _normalizeStyle($data.ulchildSstyle)
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getChildren(item, 1), (child, ids) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass({
          active: $data.childIndex === ids
        }),
        key: ids,
        style: _normalizeStyle($data.ctypeArr[index] === ids ? $data.typebtn[1] : $data.typebtn[0]),
        onClick: _withModifiers($event => $options.childtypeClick(item, index + 1, child, ids), ["stop"])
      }, _toDisplayString(child.title), 15, _hoisted_4);
    }), 128))], 6)) : _createCommentVNode("", true)], 8, _hoisted_3);
  }), 128))], 6)) : _createCommentVNode("", true)]);
}